import axiosInstance from '../helpers/axiosConfig';

class BlogService {
  static fetchAll = (params) => axiosInstance.get('/blogs', { params }); // paginacija, search, tag
  static fetchOne = (slug) => axiosInstance.get(`/blogs/${slug}`);
  static create = (data) => axiosInstance.post('/blogs', data);
  static update = (id, data) => axiosInstance.put(`/blogs/${id}`, data);
  static delete = (id) => axiosInstance.delete(`/blogs/${id}`);
}

export default BlogService;
